
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/locations/all-locations",
      function () {
        return require("private-next-pages/locations/all-locations.tsx");
      }
    ]);
  